import { useQuery } from "@tanstack/react-query";
import Chevron from "../components/Icons/Chevron";
import { Helmet } from "react-helmet";
import { GetCart } from "../api/Cart/GetCart";
import CartPaymentDetails from "../components/Payment/CartPaymentDetails";
import Spinner from "../components/Shared/Spinner";
import { useUserDataStore } from "../stores/user";

const CartCheckout = () => {
  const { userData } = useUserDataStore();
  const { data: CartData, isLoading: isLoading } = useQuery({
    queryFn: GetCart,
    queryKey: ["cart"],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!userData.id && userData.role !== "sales" && userData.role !== "admin"
  });
  const cart = CartData?.data;

  return (
    <div className="container min-h-screen md:pt-20 mt-20">
      <Helmet>
        <link rel="canonical" href="https://www.nilewisect.com/cart-checkout" />
      </Helmet>

      <div className="flex items-center gap-2 mt-16 mb-11">
        <div className="w-2 sm:h-[50px] h-8 rounded-2xl bg-primary sm:mr-1"></div>
        <div className="flex items-center gap-0.5 text-burntBlack/85 font-medium sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
          Checkout <Chevron />
        </div>
        <div className="flex items-center gap-0.5 text-burntBlack font-semibold sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
          Payment
        </div>
      </div>
      <div className="flex justify-between gap-11">
        {isLoading ? (
          <div className="flex w-full h-[30vh] items-center justify-center">
            <Spinner />
          </div>
        ) : (
          cart && <CartPaymentDetails cart={cart} />
        )}
      </div>
    </div>
  );
};

export default CartCheckout;
